import React from "react";
import PropTypes from "prop-types";

import styles from "forms/forms.css";

const FormFooter = ({ children }) => <div className={styles.footer}>{children}</div>;

FormFooter.propTypes = {
  children: PropTypes.node,
};

export default FormFooter;
